import ReducerUtils                   from "../../../utils/ReducerUtils"
import Actions                        from "../../../model/constant/actions"

const FailedMoveProxySimulation = ReducerUtils.createReducer<boolean>(false,{
  [Actions.FAILED_SIMULATION_MOVING_PROXY] : (state,action) => action.status
})

export default FailedMoveProxySimulation
